export default {"src":"/_next/static/media/login-icon-white.70a37a21.svg","height":10,"width":9};